import React, { memo } from 'react';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import { formatCompactCount, formatCount } from 'src/utils/formatNumber.util';

const WarningContainer = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: theme.spacing(0.7),
  right: theme.spacing(1),
  backgroundColor: 'transparent',
  border: '1px solid #FFA726',
  borderRadius: theme.spacing(2),
  padding: '6px',
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(0.5),
  transition: 'all 0.2s ease-in-out',
  '&:hover': {
    backgroundColor: '#FFA726',
    boxShadow: '0 4px 12px rgba(255, 167, 38, 0.4)',
    transform: 'translateY(-1px)',
    '& .warning-text': {
      color: '#000',
    },
  },
}));

const WarningIcon = styled('span')({
  fontSize: '14px',
  lineHeight: 1,
});

const WarningText = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.pxToRem(12),
  fontWeight: 'bold',
  color: '#FFA726',
  lineHeight: 1,
}));

const WarningBadge = ({ count, onClick, type = 'Issues' }) => {
  if (!count || count === 0) return null;

  return (
    <WarningContainer onClick={onClick} title={`${formatCount(count)} ${type}`}>
      <WarningIcon>⚠️</WarningIcon>
      <WarningText className="warning-text">
        {formatCompactCount(count)} {type}
      </WarningText>
    </WarningContainer>
  );
};

export default memo(WarningBadge);
